import CloseIcon from '@mui/icons-material/Close';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
} from '@mui/material';
import React from 'react';
import { youtubeEmbedUrl } from '../../helpers/tutorials';

export default function YoutubeTutorialDialog({
    open,
    onClose,
    videoUrl,
    title,
}) {
    const embedUrl = youtubeEmbedUrl(videoUrl);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            keepMounted={false}
        >
            <DialogTitle sx={{ pr: 6 }}>
                {title || 'Tutorial'}
                <IconButton
                    aria-label="fechar"
                    onClick={onClose}
                    sx={{ position: 'absolute', right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ pt: 0 }}>
                <Box
                    sx={{
                        position: 'relative',
                        width: '100%',
                        pt: '56.25%',
                        bgcolor: '#000',
                        borderRadius: 1,
                        overflow: 'hidden',
                    }}
                >
                    {open && embedUrl ? (
                        <Box
                            component="iframe"
                            src={embedUrl}
                            title={title || 'Tutorial'}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                            sx={{
                                position: 'absolute',
                                inset: 0,
                                width: '100%',
                                height: '100%',
                                border: 0,
                            }}
                        />
                    ) : null}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Fechar</Button>
            </DialogActions>
        </Dialog>
    );
}
